import Helpers from '../helpers'

export default {
    mixins: [Helpers],

    methods: {
        trackViewItemList() {
            let itemsList = [];
            let position = 1;
            let airportCode = apr.search_apr.airport.code;

            // Available
            _.forEach(this.search, (item) => {
                let category = this.getLotCategory(item.provider);
                let price = item.rate != 'undefined' ? item.rate : 0.00;
                let taxesIncluded = !!item.taxes_included;
                let discount = item.baseRate
                    ? parseFloat(_.floor(item.baseRate - price, 2).toFixed(2)) // This is to get rid of repeating decimals
                    : 0;

                const product = {
                    'item_id': item.id ? item.id : item.hotel_id,
                    'item_name': `${airportCode} ${item.name}`,
                    'coupon': '',
                    'discount': discount,
                    'item_list_position': position,
                    'item_category': category,
                    'item_list_name': 'Search Results',
                    'item_variant': 'available',
                    'price': price,
                    'salesTaxIncluded': taxesIncluded,
                    'feesIncluded': false,
                    'fees': 0,
                    'tax': 0,
                    'quantity': 1,
                };

                itemsList.push(product);
                position++;
            });

            // Soldout
            _.forEach(this.soldout, (item) => {
                // Soldout items are APR parking lots only — PSF hotels use hotel_id (not id) and are excluded
                // by the soldout computed filter in resources/desktop/js/pages/search.js and resources/mobile/js/pages/search.js
                // getLotCategory defaults to 'Airport Parking Only' when provider is absent
                let category = this.getLotCategory(item.provider);
                const product = {
                    'item_id': item.id ? item.id : item.hotel_id,
                    'item_name': `${airportCode} ${item.name}`,
                    'coupon': '',
                    'discount': 0,
                    'item_list_position': position,
                    'item_category': category,
                    'item_list_name': 'Search Results',
                    'item_variant': 'sold out',
                    'price': 0.00,
                    'salesTaxIncluded': false,
                    'feesIncluded': false,
                    'fees': 0,
                    'tax': 0,
                    'quantity': 1,
                };

                itemsList.push(product);
                position++;
            });

            //dataLayer - view_item_list
            const airportCountry = _.get(apr, 'search_apr.airport.address.country');
            const currency = airportCountry === 'Canada' ? 'CAD' : 'USD';
            dataLayer.push({
                'event': 'view_item_list',
                'currency': currency,
                'ecommerce': {
                    'items': itemsList
                }
            });
        },
    }
}